import {CalendarFrequencyType} from 'constants'
import ClassicBridge from '../next/ClassicBridge'

export function BaseBalanceRulesControl()
{

}

export const BALANCE_RULES_VALUES = {};
BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED = "AccrualRuleEnabled";
BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE = "AccrualRuleValue";
BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE = "AccrualRuleFrequencyTypeName";
BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS = "AccrualRuleParameters";
BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE = "ResetRuleFrequencyTypeName";
BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS = "ResetRuleParameters";
BALANCE_RULES_VALUES.RESET_RULE_ENABLED = "ResetRuleEnabled";
BALANCE_RULES_VALUES.RESET_RULE_VALUE = "ResetRuleValue";
BALANCE_RULES_VALUES.CAP_RULE_ENABLED = "CapRuleEnabled";
BALANCE_RULES_VALUES.CAP_RULE_VALUE = "CapRuleValue";

BaseBalanceRulesControl.DEFAULT_VALUES = {};
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED] = true;
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE] = 2;
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE] = "MONTHLY";
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS] = [1];
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE] = "YEARLY";
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS] = [1, 1];
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.RESET_RULE_ENABLED] = true;
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.RESET_RULE_VALUE] = 0;
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.CAP_RULE_ENABLED] = true;
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.CAP_RULE_VALUE] = 30;

BaseBalanceRulesControl.prototype.init = function( countHoursPerDay )
{
    this.values = null;
    this.defaultValues = BaseBalanceRulesControl.DEFAULT_VALUES;

    this.defaultWorkDayDuration = countHoursPerDay;

    this.units = LeaveBalanceUnits.DAYS;
};

// abstract
BaseBalanceRulesControl.prototype._fillElementsWithValues = function(useDefault)
{

};

BaseBalanceRulesControl.prototype.setValues = function(values)
{
    this.values = values;

    if (this.values && this.units == LeaveBalanceUnits.HOURS)
        this._recalculateValuesFromDaysToHours(this.values);

    if (!this.values)
    {
        this._fillElementsWithValues(true, true);
        this.values = null;
        return;
    }

    this._fillElementsWithValues(false);
};

BaseBalanceRulesControl.prototype.setBalanceData = function(balanceData)
{
    this.setValues(this._getValuesFromBalanaceData(balanceData));
};

BaseBalanceRulesControl.prototype.setDefaultBalanceData = function(defaultBalanceData)
{
    this.defaultValues = this._getValuesFromBalanaceData(defaultBalanceData);
    if (!this.defaultValues)
        this.defaultValues = BaseBalanceRulesControl.DEFAULT_VALUES;

    if (defaultBalanceData && defaultBalanceData.showBalanceInHours)
        this.setBalanceUnits(LeaveBalanceUnits.HOURS)
};

BaseBalanceRulesControl.prototype._getValues = function()
{
    return this.values ? this.values : this.defaultValues;
};

BaseBalanceRulesControl.prototype.setBalanceUnits = function(units)
{
    this._recalculateTo(units);
};

BaseBalanceRulesControl.prototype.setWorkdayDuration = function(defaultWorkDayDuration)
{
    this.defaultWorkDayDuration = defaultWorkDayDuration / 60;
};

BaseBalanceRulesControl.prototype.setWorkdayDurationInHours = function(defaultWorkDayDurationInHours)
{
    this.defaultWorkDayDuration = defaultWorkDayDurationInHours;
};

BaseBalanceRulesControl.prototype._recalculateTo = function(newUnits)
{
    if (newUnits == LeaveBalanceUnits.DAYS && this.units == LeaveBalanceUnits.HOURS)
        this._recalculateFromHoursToDays();
    else if (newUnits == LeaveBalanceUnits.HOURS && this.units == LeaveBalanceUnits.DAYS)
        this._recalculateFromDaysToHours();
};

BaseBalanceRulesControl.prototype._recalculateFromHoursToDays = function()
{
    this._recalculateValuesFromHoursToDays(this.values);
    this._recalculateValuesFromHoursToDays(this.defaultValues);

    this.units = LeaveBalanceUnits.DAYS;
};

BaseBalanceRulesControl.prototype._recalculateFromDaysToHours = function()
{
    this._recalculateValuesFromDaysToHours(this.values);
    this._recalculateValuesFromDaysToHours(this.defaultValues);

    this.units = LeaveBalanceUnits.HOURS;
};

BaseBalanceRulesControl.prototype._recalculateValuesFromHoursToDays = function(values)
{
    this._recalculateValueFromHoursToDays(values, BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE);
    this._recalculateValueFromHoursToDays(values, BALANCE_RULES_VALUES.RESET_RULE_VALUE);
    this._recalculateValueFromHoursToDays(values, BALANCE_RULES_VALUES.CAP_RULE_VALUE);
};

BaseBalanceRulesControl.prototype._recalculateValuesFromDaysToHours = function(values)
{
    this._recalculateValueFromDaysToHours(values, BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE);
    this._recalculateValueFromDaysToHours(values, BALANCE_RULES_VALUES.RESET_RULE_VALUE);
    this._recalculateValueFromDaysToHours(values, BALANCE_RULES_VALUES.CAP_RULE_VALUE);
};

BaseBalanceRulesControl.prototype._recalculateValueFromHoursToDays = function(values, key)
{
    if (values)
        values[key] /= this.defaultWorkDayDuration;
};

BaseBalanceRulesControl.prototype._recalculateValueFromDaysToHours = function(values, key)
{
    if (values)
        values[key] *= this.defaultWorkDayDuration;
};

BaseBalanceRulesControl.prototype._getDefaultValueInDays = function(key)
{
    var valueInDays = this.defaultValues[key];
    if (this.units == LeaveBalanceUnits.HOURS)
        valueInDays /= this.defaultWorkDayDuration;
    return valueInDays;
};

BaseBalanceRulesControl.prototype._getValuesFromBalanaceData = function(balanceData)
{
    if (!balanceData)
        return null;

    var values = {};

    values[BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED] = balanceData.accrualRule ? true : false;
    if (values[BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED])
    {
        values[BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE] = balanceData.accrualRule.value;
        values[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE] = balanceData.accrualRule.frequency.type;
        values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS] = balanceData.accrualRule.frequency.params;
    }
    else
    {
        values[BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE] = this._getDefaultValueInDays(BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE);
        values[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE] = this.defaultValues[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE];
        values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS] = this.defaultValues[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS];
    }

    if(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE] == CalendarFrequencyType.ON_HIRE_DATE){
        values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS] = [balanceData.hireDate];
    }

    values[BALANCE_RULES_VALUES.RESET_RULE_ENABLED] = balanceData.resetRule ? true : false;
    if (values[BALANCE_RULES_VALUES.RESET_RULE_ENABLED])
    {
        values[BALANCE_RULES_VALUES.RESET_RULE_VALUE] = balanceData.resetRule.value;
        values[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE] = balanceData.resetRule.frequency.type;
        values[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS] = balanceData.resetRule.frequency.params;
    }
    else
    {
        values[BALANCE_RULES_VALUES.RESET_RULE_VALUE] = this._getDefaultValueInDays(BALANCE_RULES_VALUES.RESET_RULE_VALUE);
        values[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE] = this.defaultValues[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE];
        values[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS] = this.defaultValues[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS];
    }
    if(values[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE] == CalendarFrequencyType.ON_HIRE_DATE){
        values[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS] = [balanceData.hireDate];
    }

    values[BALANCE_RULES_VALUES.CAP_RULE_ENABLED] = balanceData.balanceCap !== null;
    if (values[BALANCE_RULES_VALUES.CAP_RULE_ENABLED])
        values[BALANCE_RULES_VALUES.CAP_RULE_VALUE] = balanceData.balanceCap;
    else
        values[BALANCE_RULES_VALUES.CAP_RULE_VALUE] = this._getDefaultValueInDays(BALANCE_RULES_VALUES.CAP_RULE_VALUE);

    return values;
};

/**
 * Requires: smart_field.js, constants_js.jsp, system_settings_js.jsp, date_js.jsp, dropdown_list_button.js
 * @param balanceRulesTypePrefix
 * @param parameters
 * parameters[accrueRuleLabel]
 * parameters[resetRuleLabel]
 * parameters[capRuleLabel]
 * @param changesCallback
 * @param countHoursPerDay
 * @param [decimalSeparator]
 * @param scrollableContainer
 **/

export function BalanceRulesEditor({
    balanceRulesTypePrefix = '',
    parameters = {},
    changesCallback = () => {},
    countHoursPerDay = '',
    decimalSeparator = '',
    scrollableContainer = null
} = {}) {
    this.balanceRulesTypePrefix = balanceRulesTypePrefix
    this.parameters = parameters
    this._changesCallback = changesCallback
    this.countHoursPerDay = countHoursPerDay
    this._decimalSeparator = decimalSeparator ? decimalSeparator : SystemSettings.decimalSeparator;
    this.scrollableContainer = scrollableContainer
}

BalanceRulesEditor.prototype = new BaseBalanceRulesControl();

/**
 * Init BalanceRulesEditor
 */
BalanceRulesEditor.prototype.init = function()
{
    BaseBalanceRulesControl.prototype.init.call( this, this.countHoursPerDay );

    var MAX_DAYS_VALUE_LENGTH = 6;
    var MAX_DAYS_FRACTIONAL_DIGITS = 2;

    this.contentDiv = this._getElementById("modifyBalanceAccrualRules");
    var self = this;

    this._supressButtonChangeEvent = false;

    var accrueBalanceFieldEl = this._getElementById('accrueBalanceField');
    var resetBalanceFieldEl = this._getElementById('resetBalanceField');
    var capBalanceFieldEl = this._getElementById('capBalanceField');

    accrueBalanceFieldEl.off();
    resetBalanceFieldEl.off();
    capBalanceFieldEl.off();

    this.accrueBalanceField = new DecimalField(accrueBalanceFieldEl, false, MAX_DAYS_VALUE_LENGTH, MAX_DAYS_FRACTIONAL_DIGITS,
                                           this._decimalSeparator, true, SystemSettings.digitGroupingSymbol,
                                           messageResource.getMessage('common.js.invalid_number', this._decimalSeparator) );
    this.resetBalanceField = new DecimalField(resetBalanceFieldEl, false, MAX_DAYS_VALUE_LENGTH, MAX_DAYS_FRACTIONAL_DIGITS,
                                          this._decimalSeparator, true, SystemSettings.digitGroupingSymbol,
                                          messageResource.getMessage('common.js.invalid_number', this._decimalSeparator) );
    this.capBalanceField = new DecimalField(capBalanceFieldEl, false, MAX_DAYS_VALUE_LENGTH, MAX_DAYS_FRACTIONAL_DIGITS,
                                        this._decimalSeparator, true, SystemSettings.digitGroupingSymbol,
                                        messageResource.getMessage('common.js.invalid_number', this._decimalSeparator) );

    this._createPeriodSelect(this._getElementById('accruePeriodSelectPlaceholder'), this._getIdElement('accruePeriodSelect'));
    this._createResetPeriodSelect(this._getElementById('resetPeriodSelectPlaceholder'), this._getIdElement('resetPeriodSelect'));
    this._createMonthDaySelect(this._getElementById('accrueMonthDaySelectPlaceholder'), this._getIdElement('accrueMonthDaySelect'));
    this._createMonthSelect(this._getElementById('accrueMonthSelectPlaceholder'), this._getIdElement('accrueMonthSelect'));
    this._createWeekDaySelect(this._getElementById('accrueWeekdaySelectPlaceholder'), this._getIdElement('accrueWeekdaySelect'));
    this._createMonthSelect(this._getElementById("resetMonthSelectPlaceholder"),this._getIdElement("resetMonthSelect"));
    this._createMonthDaySelect(this._getElementById('resetMonthDaySelectPlaceholder'),this._getIdElement('resetMonthDaySelect'));

    this.accruePeriodButton = new AT.DropdownListButton({ menuCls: 'accruePeriod', applyTo: this._getIdElement('accruePeriodSelect'), scrollableContainer: this.scrollableContainer  });
    this.accrueWeekdayButton = new AT.DropdownListButton({  menuCls: 'accrueWeekday', applyTo: this._getIdElement('accrueWeekdaySelect'), scrollableContainer: this.scrollableContainer });
    this.accrueMonthDayButton = new AT.DropdownListButton({ applyTo: this._getIdElement('accrueMonthDaySelect'), menuCls: 'accrual-rules-day-selector-menu', scrollableContainer: this.scrollableContainer });
    this.accrueMonthButton = new AT.DropdownListButton({ applyTo: this._getIdElement('accrueMonthSelect'), menuCls: 'accrual-rules-month-selector-menu', scrollableContainer: this.scrollableContainer });
    this.accrueFromDateSelector = new AccrualRuleFromDateSelector(
        this._getElementById('accrueFromDateSelectorPlaceholder')[0],
        SystemSettings.dateFormat,
        function () { self.updateDefaultBalanceNote() }
    )
    this.accrueParamsPrefix =this._getElementById("accrueParamsPrefix");
    this.resetPeriodButton = new AT.DropdownListButton({ menuCls: 'resetPeriod', applyTo: this._getIdElement('resetPeriodSelect'), scrollableContainer: this.scrollableContainer  });
    this.resetMonthButton = new AT.DropdownListButton({ menuCls: 'resetMonthSelect',  applyTo: this._getIdElement('resetMonthSelect'),scrollableContainer: this.scrollableContainer });
    this.resetMonthDayButton = new AT.DropdownListButton({ applyTo: this._getIdElement('resetMonthDaySelect'), menuCls: 'accrual-rules-day-selector-menu', scrollableContainer: this.scrollableContainer });
    this.resetOnWordCell =this._getElementById("resetOn");


    this._showAppropriateAccrualPeriodParameters();

    this._formatAccrualMonthDayButtonText(this.accrueMonthDayButton);
    this._formatResetMonthDayButtonText(this.resetMonthDayButton);

    this._addButtonChangeHandler(this.accruePeriodButton, function() {
        self.updateDefaultBalanceNote();
        self._showAppropriateAccrualPeriodParameters();
    });
    this._addButtonChangeHandler(this.accrueWeekdayButton, function() { self._showAppropriateAccrualPeriodParameters(); });
    this._addButtonChangeHandler(this.accrueMonthButton, function() {
        self._setCorrectDayOfMonthForAccrualRuleIfNeeded();
    });
    this._addButtonChangeHandler(this.accrueMonthDayButton, function() {
        self._setCorrectDayOfMonthForAccrualRuleIfNeeded();
        self._formatAccrualMonthDayButtonText(self.accrueMonthDayButton);
    });
    this._addButtonChangeHandler(this.accruePeriodButton, function() {
        self._setCorrectDayOfMonthForAccrualRuleIfNeeded();
        self._formatAccrualMonthDayButtonText(self.accrueMonthDayButton);
    });

    this._addButtonChangeHandler(this.resetPeriodButton, function() { self._showAppropriateResetPeriodParameters(); });
    this._addButtonChangeHandler(this.resetMonthButton, function() {
        self._setCorrectDayOfMonth(self.resetMonthButton, self.resetMonthDayButton);
    });
    this._addButtonChangeHandler(this.resetMonthDayButton, function() {
        self._setCorrectDayOfMonth(self.resetMonthButton, self.resetMonthDayButton);
        self._formatResetMonthDayButtonText(self.resetMonthDayButton);
    });

    this.accrueRuleSection = {
        checkbox: this._getElementById('accrueRuleCheckbox'),
        valueField: this.accrueBalanceField,
        valueFieldEl: accrueBalanceFieldEl,
        buttons: [this.accruePeriodButton, this.accrueWeekdayButton, this.accrueMonthDayButton, this.accrueMonthButton, this.accrueFromDateSelector]
    };
    this.resetRuleSection = {
        checkbox: this._getElementById('resetRuleCheckbox'),
        valueField: this.resetBalanceField,
        valueFieldEl: resetBalanceFieldEl,
        buttons: [this.resetPeriodButton, this.resetMonthButton, this.resetMonthDayButton]
    };
    this.capRuleSection = {
        checkbox: this._getElementById('capRuleCheckbox'),
        valueField: this.capBalanceField,
        valueFieldEl: capBalanceFieldEl,
        buttons: []
    };

    this.sections = [this.accrueRuleSection, this.resetRuleSection, this.capRuleSection];

    $.each( this.sections, function() {
        self._addCheckboxClickHandler(this);
    });

    this._addFieldBlurHandler(this.accrueRuleSection, BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE);
    this._addFieldBlurHandler(this.resetRuleSection, BALANCE_RULES_VALUES.RESET_RULE_VALUE);
    this._addFieldBlurHandler(this.capRuleSection, BALANCE_RULES_VALUES.CAP_RULE_VALUE);

    this.setBalanceUnits(LeaveBalanceUnits.DAYS);

};

BalanceRulesEditor.prototype._getElementById = function(element){
    return $("#" + this.balanceRulesTypePrefix + "_" + element);
};

BalanceRulesEditor.prototype._getIdElement = function(postfix){
    return   this.balanceRulesTypePrefix + "_" + postfix;
};

BalanceRulesEditor.prototype._getMaxDayOfMonth = function(month)
{
    return new Date(2011, month, 0).getDate(); // 2011 is a non-leap year, February 29 is disallowed
};

BalanceRulesEditor.prototype._setCorrectDayOfMonthForAccrualRuleIfNeeded = function()
{
    if (this.accruePeriodButton.getValue() == CalendarFrequencyType.YEARLY)
        this._setCorrectDayOfMonth(this.accrueMonthButton, this.accrueMonthDayButton);
};

BalanceRulesEditor.prototype._setCorrectDayOfMonth = function(monthButton, monthDayButton)
{
    var maxDaysInMonth = this._getMaxDayOfMonth(monthButton.getValue());
    if (monthDayButton.getValue() > maxDaysInMonth)
        monthDayButton.setActiveItemByPosition(maxDaysInMonth - 1);
};

BalanceRulesEditor.prototype._addCheckboxClickHandler = function(section)
{
    var self = this;
    section.checkbox.unbind("click").click( function() {
        var checked = $(this).attr('checked');
        if (checked)
            self._enableSection(section);
        else
            self._disableSection(section, false);
        self._onChange();
    });
};

BalanceRulesEditor.prototype._addFieldBlurHandler = function(section, key)
{
    var self = this;
    section.valueFieldEl.blur(function(){
        self._validateField(section);

        var oldValue = section.valueField.oldValue !== undefined ? section.valueField.oldValue :
                       ( self.values ? self.values[key] : self.defaultValues[key] );
        var valueChanged = oldValue != section.valueField.getValue();

        self._updateOldValueOfField( section.valueField );

        if( ( section.valueField.getValue() == "" && oldValue == 0 ) || ( section.valueField.getValue() == 0 && oldValue === "" ) ) {
            valueChanged = true;
        }

        if (section.valueField.isValid())
        {
            if (self.values)
                self.values[key] = section.valueField.getValueAsNumber();
        }

        if ( valueChanged )
            self._onChange();
    });
};

BalanceRulesEditor.prototype._updateOldValueOfField = function(field)
{
    field.oldValue = field.getValue();
};

BalanceRulesEditor.prototype._addButtonChangeHandler = function(button, handler)
{
    var self = this;
    button.addListener('change', function() {
        if (handler)
            handler();
        if (!self._supressButtonChangeEvent)
            self._onChange();
    });
};

BalanceRulesEditor.prototype._formatAccrualMonthDayButtonText = function(button)
{
    if (this.accruePeriodButton.getValue() == CalendarFrequencyType.MONTHLY)
        button.setText(formatMonthDay(button.getValue()));
    else {
        var buttonValue = button.getValue();
        if (buttonValue < 10) {
            button.setText('0' + buttonValue);
        } else {
            button.setText(buttonValue);
        }
    }
};

BalanceRulesEditor.prototype._formatResetMonthDayButtonText = function(button)
{
    var buttonText = button.getText();
    if (buttonText < 10)
        button.setText('0' + buttonText);
};

BalanceRulesEditor.prototype._onChange = function()
{
    if (this._changesCallback)
        this._changesCallback();
};

BalanceRulesEditor.prototype._validateField = function(section)
{
    section.valueField.process();
};

BalanceRulesEditor.prototype._clearFieldValidationResult = function(section)
{
    section.valueField.clearValidationResult();
};

BalanceRulesEditor.prototype._enableSection = function(section)
{
    section.valueFieldEl.prop('disabled', false);
    this._validateField(section);
    for (var i=0; i<section.buttons.length; i++)
        section.buttons[i].enable();
    section.checkbox.prop('disabled', false);
};

BalanceRulesEditor.prototype._disableSection = function(section, disableCheckbox)
{
    this._clearFieldValidationResult(section);
    section.valueFieldEl.prop('disabled', true);
    for (var i=0; i<section.buttons.length; i++)
        section.buttons[i].disable();
    if (disableCheckbox)
        section.checkbox.prop('disabled', true);
};

BalanceRulesEditor.prototype.setToday = function(today)
{
    this.today = today
}

BalanceRulesEditor.prototype._fillElementsWithValues = function(useDefault)
{
    var values = useDefault ? this.defaultValues : this._getValues();

    this._supressButtonChangeEvent = true;

    this.accrueRuleSection.checkbox.attr('checked', values[BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED]);
    this._fillSectionFieldWithValue(this.accrueRuleSection, values[BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE]);
    this.accruePeriodButton.setActiveItemByValue(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE]);

    if (this.accruePeriodButton.getValue() !== CalendarFrequencyType.BIWEEKLY) {
        this.accrueFromDateSelector.setPlaceholderDateValue(this.today)
    }


    switch (this.accruePeriodButton.getValue())
    {
        case CalendarFrequencyType.WEEKLY:
            this.accrueWeekdayButton.setActiveItemByValue(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS]);
            break;
        case CalendarFrequencyType.BIWEEKLY:
            this.accrueFromDateSelector.setDates(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS][0], this.today);
            break;
        case CalendarFrequencyType.YEARLY:
            this.accrueMonthDayButton.setActiveItemByValue(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS][1]);
            this.accrueMonthButton.setActiveItemByValue(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS][0]);
            break;
        case CalendarFrequencyType.ON_HIRE_DATE:
            break;
        case CalendarFrequencyType.MONTHLY:
            this.accrueMonthDayButton.setActiveItemByValue(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS]);
            break;
    }

    this.resetRuleSection.checkbox.attr('checked', values[BALANCE_RULES_VALUES.RESET_RULE_ENABLED]);
    this._fillSectionFieldWithValue(this.resetRuleSection, values[BALANCE_RULES_VALUES.RESET_RULE_VALUE]);
    this.resetPeriodButton.setActiveItemByValue(values[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE]);
    switch (this.resetPeriodButton.getValue())
    {
        case CalendarFrequencyType.YEARLY:
            this.resetMonthButton.setActiveItemByValue(values[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS][0]);
            this.resetMonthDayButton.setActiveItemByValue(values[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS][1]);
            break;
        case CalendarFrequencyType.ON_HIRE_DATE:
            break;
    }

    this.capRuleSection.checkbox.attr('checked', values[BALANCE_RULES_VALUES.CAP_RULE_ENABLED]);
    this._fillSectionFieldWithValue(this.capRuleSection, values[BALANCE_RULES_VALUES.CAP_RULE_VALUE]);

    var self = this;
    $.each( this.sections, function() {
        var checked = this.checkbox.attr('checked');
        if (!checked)
            self._disableSection(this);
        else
            self._enableSection(this);

        this.checkbox[0].defaultValue = checked ? "on" : "off";
    });

    this._supressButtonChangeEvent = false;

};

BalanceRulesEditor.prototype._fillSectionFieldWithValue = function(section, value)
{
    section.valueField.setValueAsNumber(value);
    section.valueFieldEl[0].defaultValue = section.valueField.getValue();
    this._updateOldValueOfField( section.valueField );
};

BalanceRulesEditor.prototype._getAppropriateAccrualPeriodParametersControls = function()
{
    var result = [];

    switch (this.accruePeriodButton.getValue())
    {
        case CalendarFrequencyType.WEEKLY:
            result.push(this.accrueWeekdayButton);
            break;
        case CalendarFrequencyType.MONTHLY:
            result.push(this.accrueMonthDayButton);
            break;
        case CalendarFrequencyType.YEARLY:
            result.push(this.accrueMonthButton);
            result.push(this.accrueMonthDayButton);
            break;
        case CalendarFrequencyType.BIWEEKLY:
            result.push(this.accrueFromDateSelector);
            break;
        case CalendarFrequencyType.ON_HIRE_DATE:
            break;
    }

    return result;
};

BalanceRulesEditor.prototype._getAppropriateResetPeriodParametersControls = function()
{
    var result = [];

    switch (this.resetPeriodButton.getValue())
    {
        case CalendarFrequencyType.YEARLY:
            result.push(this.resetMonthButton);
            result.push(this.resetMonthDayButton);
            break;
        case CalendarFrequencyType.ON_HIRE_DATE:
            break;
    }

    return result;
};


BalanceRulesEditor.prototype._createPeriodSelect = function(element, id)
{
    var select = '<select id="' + id + '">';

    select += "<option value='" + CalendarFrequencyType.WEEKLY + "'>" + CalendarFrequencyType.descriptionFor[CalendarFrequencyType.WEEKLY] + "</option>";
    select += "<option value='" + CalendarFrequencyType.BIWEEKLY + "'>" + CalendarFrequencyType.descriptionFor[CalendarFrequencyType.BIWEEKLY] + "</option>";
    select += "<option value='" + CalendarFrequencyType.MONTHLY + "'>" + CalendarFrequencyType.descriptionFor[CalendarFrequencyType.MONTHLY] + "</option>";
    select += "<option value='" + CalendarFrequencyType.YEARLY + "'>" + CalendarFrequencyType.descriptionFor[CalendarFrequencyType.YEARLY] + "</option>";
    select += "<option value='" + CalendarFrequencyType.ON_HIRE_DATE + "'>" + CalendarFrequencyType.descriptionFor[CalendarFrequencyType.ON_HIRE_DATE] + "</option>";

    select += "</select>";

    $(element).html(select);
};

BalanceRulesEditor.prototype._createResetPeriodSelect = function(element, id)
{
    var select = '<select id="' + id + '">';

    select += "<option value='" + CalendarFrequencyType.YEARLY + "'>" + CalendarFrequencyType.descriptionFor[CalendarFrequencyType.YEARLY] + "</option>";
    select += "<option value='" + CalendarFrequencyType.ON_HIRE_DATE + "'>" + CalendarFrequencyType.descriptionFor[CalendarFrequencyType.ON_HIRE_DATE] + "</option>";

    select += "</select>";

    $(element).html(select);
};

BalanceRulesEditor.prototype._createMonthDaySelect = function(element, id)
{
    var select = '<select id="' + id + '">';

    for (var i = 1; i <= 31; i++)
        select += "<option value='" + i + "'>" + i + "</option>";

    select += "</select>";

    $(element).html(select);
};

BalanceRulesEditor.prototype._createMonthSelect = function(element, id)
{
    var select = '<select id="' + id + '">';

    var monthNames = Date.monthNamesShort;

    for (var i = 0; i < monthNames.length; i++)
        select += "<option value='" + (i+1) + "'>" + monthNames[i] + "</option>";

    select += "</select>";

    $(element).html(select);
};

BalanceRulesEditor.prototype._createWeekDaySelect = function(element, id)
{
    var select = '<select id="' + id + '">';

    var weekStartDay = SystemSettings.weekStartDay - 1;

    for (var i = 1; i <= 7; i++)
    {
        var dayOfWeek = (weekStartDay + i - 1) % 7;
        var dayOfWeekName = Date.dayNamesShort[dayOfWeek];
        select += "<option value='" + (dayOfWeek + 1) + "'>" + dayOfWeekName +"</option>";
    }

    select += "</select>";

    $(element).html(select);
};

BalanceRulesEditor.prototype._showAppropriateAccrualPeriodParameters = function()
{
    this.accrueWeekdayButton.hide();
    this.accrueMonthDayButton.hide();
    this.accrueMonthButton.hide();
    this.accrueFromDateSelector.hide()

    if (this.accruePeriodButton.getValue() == CalendarFrequencyType.ON_HIRE_DATE) {
        this.accrueParamsPrefix.hide();
    } else {
        var prefix = ''
        if (this.accruePeriodButton.getValue() == CalendarFrequencyType.BIWEEKLY) {
            prefix = messageResource.getMessage('balance_editor.from')
        } else {
            prefix = messageResource.getMessage('balance_editor.on')
        }

        this.accrueParamsPrefix.html(prefix)
        this.accrueParamsPrefix.show();
    }

    $.each( this._getAppropriateAccrualPeriodParametersControls(), function() { this.show() } );
};

BalanceRulesEditor.prototype._showAppropriateResetPeriodParameters = function()
{
    this.resetMonthDayButton.hide();
    this.resetMonthButton.hide();


    if (this.resetPeriodButton.getValue() == CalendarFrequencyType.ON_HIRE_DATE)
        this.resetOnWordCell.hide();
    else
        this.resetOnWordCell.show();

    $.each( this._getAppropriateResetPeriodParametersControls(), function() { this.show() } );
};


BalanceRulesEditor.prototype.hasErrors = function()
{
    var self = this;
    var hasErrors = false;
    $.each( this.sections, function() {
        if (self._hasError(this))
            hasErrors = true;
    });
    return hasErrors;
};

BalanceRulesEditor.prototype._hasError = function(section)
{
    var enabled = section.checkbox.attr('checked');
    if (enabled)
    {
        section.valueField.process();

        if (!section.valueField.isValid())
            return true;
    }
    return false;
};

BalanceRulesEditor.prototype.getValues = function()
{
    var values = [];

    var accrueEnabled = this.accrueRuleSection.checkbox.attr('checked') == 'checked';
    var resetEnabled = this.resetRuleSection.checkbox.attr('checked') == 'checked';
    var capEnabled = this.capRuleSection.checkbox.attr('checked') == 'checked';

    var accrualFrequencyParameterControls = this._getAppropriateAccrualPeriodParametersControls();
    var accrualFrequencyParameters = [];

    $.each( accrualFrequencyParameterControls, function() {
        accrualFrequencyParameters.push( this.getValue() );
    });

    var resetFrequencyParameterControls = this._getAppropriateResetPeriodParametersControls();
    var resetFrequencyParameters = [];

    $.each( resetFrequencyParameterControls, function() {
        resetFrequencyParameters.push( this.getValue() );
    });


    var accrualRuleValue = this.accrueRuleSection.valueField.getValueAsNumber();
    var resetRuleValue = this.resetRuleSection.valueField.getValueAsNumber();
    var capRuleValue = this.capRuleSection.valueField.getValueAsNumber();
    if (this.units == LeaveBalanceUnits.HOURS)
    {
        accrualRuleValue /= this.defaultWorkDayDuration;
        resetRuleValue /= this.defaultWorkDayDuration;
        capRuleValue /= this.defaultWorkDayDuration;
    }

    values.push({name: BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED, value: accrueEnabled});
    if (this.accrueRuleSection.valueField.isValid())
        values.push({name: BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE, value: accrualRuleValue});
    values.push({name: BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE, value: this.accruePeriodButton.getValue()});
    values.push({name: BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS, value: accrualFrequencyParameters});

    values.push({name: BALANCE_RULES_VALUES.RESET_RULE_ENABLED, value: resetEnabled});
    if (this.resetRuleSection.valueField.isValid())
        values.push({name: BALANCE_RULES_VALUES.RESET_RULE_VALUE, value: resetRuleValue});
    values.push({name: BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE, value: this.resetPeriodButton.getValue()});
    values.push({name: BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS, value: resetFrequencyParameters});

    if (this.capRuleSection.valueField.isValid())
        values.push({name: BALANCE_RULES_VALUES.CAP_RULE_VALUE, value: capRuleValue});
    values.push({name: BALANCE_RULES_VALUES.CAP_RULE_ENABLED, value: capEnabled});

    return values;
};

BalanceRulesEditor.prototype.getAccrualRules = function ()
{
    var newValues = this.getValuesAsMap();
    var accrualRule = null;
    var resetRule = null;
    var capRule = null;

    if (newValues[BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED]) {
        accrualRule = {
            value: newValues[BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE],
            frequency: {
                type: newValues[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE],
                params: newValues[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS]
            }
        };
    }
    if (newValues[BALANCE_RULES_VALUES.RESET_RULE_ENABLED]) {
        resetRule = {
            value: newValues[BALANCE_RULES_VALUES.RESET_RULE_VALUE],
            frequency: {
                type: newValues[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE],
                params: newValues[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS]
            }
        };
    }
    if (newValues[BALANCE_RULES_VALUES.CAP_RULE_ENABLED]) {
        capRule = newValues[BALANCE_RULES_VALUES.CAP_RULE_VALUE];
    }

    return {accrualRule: accrualRule, resetRule: resetRule, balanceCap: capRule};
};

BalanceRulesEditor.prototype.getValuesAsMap = function()
{
    var valuesMap = {};
    var values = this.getValues();
    $.each( values, function() {
        valuesMap[this.name] = this.value;
    });
    return valuesMap;
};

BalanceRulesEditor.prototype.enable = function()
{
    var self = this;
    $.each( this.sections, function() {
        self._enableSection(this);
    });
};

BalanceRulesEditor.prototype.disable = function()
{
    var self = this;
    $.each( this.sections, function() {
        self._disableSection(this, true);
    });
};

BalanceRulesEditor.prototype._recalculateTo = function(newUnits)
{
    BaseBalanceRulesControl.prototype._recalculateTo.call( this, newUnits );

    if (this.values)
    {
        this._fillSectionFieldWithValue(this.accrueRuleSection, this.values[BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE]);
        this._fillSectionFieldWithValue(this.resetRuleSection, this.values[BALANCE_RULES_VALUES.RESET_RULE_VALUE]);
        this._fillSectionFieldWithValue(this.capRuleSection, this.values[BALANCE_RULES_VALUES.CAP_RULE_VALUE]);
    }

    this.contentDiv.toggleClass('daysMode',  this.units == LeaveBalanceUnits.DAYS);
    this.contentDiv.toggleClass('hoursMode', this.units == LeaveBalanceUnits.HOURS);
};

BalanceRulesEditor.prototype.updateDecimalSeparator = function()
{
    var self = this;
    $.each( this.sections, function() {
        this.valueField.setDecimalSeparator( SystemSettings.decimalSeparator );
        this.valueField.setInvalidHint( messageResource.getMessage('common.js.invalid_number', SystemSettings.decimalSeparator) );
        self._updateOldValueOfField( this.valueField );
    });
};

BalanceRulesEditor.prototype.updateDigitGroupingSymbol = function()
{
    var self = this;
    $.each( this.sections, function() {
        this.valueField.setDigitGroupingSymbol( SystemSettings.digitGroupingSymbol );
        this.valueField.oldValue = this.valueField.getValue();
        self._updateOldValueOfField( this.valueField );
    });
};

BalanceRulesEditor.prototype.getInputs = function()
{
    var inputs = [];
    $.each( this.sections, function() {
        inputs.push( this.valueFieldEl[0] );
    });
    return inputs;
};

export function AdvancedBalanceRulesEditor(
    balanceRulesTypePrefix = '',
    parameters = {},
    changesCallback = () => {},
    switcherPlaceholder = '',
    countHoursPerDay = '',
    decimalSeparator = '',
    scrollableContainer = null
) {
    this.balanceRulesTypePrefix = balanceRulesTypePrefix
    this.parameters = parameters
    this._changesCallback = changesCallback
    this.switcherPlaceholder = switcherPlaceholder
    this.countHoursPerDay = countHoursPerDay
    this._decimalSeparator = decimalSeparator ? decimalSeparator : SystemSettings.decimalSeparator;
    this.scrollableContainer = scrollableContainer
}

AdvancedBalanceRulesEditor.prototype = new BalanceRulesEditor();

AdvancedBalanceRulesEditor.prototype.init = function()
{
    BalanceRulesEditor.prototype.init.call(this);
    this._defaultsViewer = new BalanceRulesViewer();
    this._defaultsViewer.init(this.balanceRulesTypePrefix, this.contentDiv, true, this.countHoursPerDay, this._decimalSeparator);

    if (this.switcherPlaceholder)
        this._addSwitcher(this.switcherPlaceholder);

    this.setUseDefaultRules(false);
};

AdvancedBalanceRulesEditor.prototype._fillElementsWithValues = function(useDefault)
{
    BalanceRulesEditor.prototype._fillElementsWithValues.call(this, useDefault);
    this._defaultsViewer.updateValues();
};

AdvancedBalanceRulesEditor.prototype.setDefaultBalanceData = function(balanceData)
{
    BalanceRulesEditor.prototype.setDefaultBalanceData.call(this, balanceData);
    this._defaultsViewer.setDefaultBalanceData(balanceData);
};

AdvancedBalanceRulesEditor.prototype.setUseDefaultRules = function(useDefaultRules)
{
    this.useDefaultRules = useDefaultRules;

    this.contentDiv.toggleClass('editMode', !useDefaultRules);
    this.contentDiv.toggleClass('readMode', useDefaultRules);

    if (this._defaultSwitcher)
    {
        this._defaultSwitcher.toggleClass('active', useDefaultRules);
        this._customSwitcher.toggleClass('active', !useDefaultRules);
    }

    this._fillElementsWithValues(useDefaultRules);

    if(this.parameters)
    {
        var titleKey = this.parameters.titleNoteKey;
        $( ".userDefaultRulesSpan" ).html( messageResource.getMessage( titleKey ) );
    }

    this.updateDefaultBalanceNote()

    var self = this;
    $.each( this.sections, function() {
        this.checkbox.prop('disabled', useDefaultRules);
    });
};

AdvancedBalanceRulesEditor.prototype.updateDefaultBalanceNote = function ()
{
    if (this.parameters) {
        var additionalInfo = ''
        if (this.accruePeriodButton.getValue() === CalendarFrequencyType.BIWEEKLY) {
            var nextDate = ClassicBridge.getNextBiweeklyAccrualDateFromDate(this.today, this.accrueFromDateSelector.getValue(), SystemSettings.dateFormat)
            additionalInfo = '. ' + messageResource.getMessage('balance_editor.next_accrual_date', [nextDate])
        }

        var messageKey = this.useDefaultRules ? this.parameters.defaultMessageNoteKey : this.parameters.customMessageNoteKey;

        $(".defaultBalanceNote").html(messageResource.getMessage(messageKey) + additionalInfo);
    }
}


AdvancedBalanceRulesEditor.prototype.switchToHours = function ()
{
    this.setBalanceUnits(LeaveBalanceUnits.HOURS);
    this._defaultsViewer.setBalanceUnits(LeaveBalanceUnits.HOURS);
};

AdvancedBalanceRulesEditor.prototype.blinkErrors = function ()
{
    var errorEls = this.contentDiv.find(".invalid" );
    errorEls.removeClass("invalid");
    window.setTimeout( function () { errorEls.addClass("invalid"); }, 250 );
};

AdvancedBalanceRulesEditor.prototype._addSwitcher = function (switcherPlaceholder, changeCallback)
{
    this._defaultCustomSwitcher = this._createSwitcher( switcherPlaceholder );
    this._defaultSwitcher = this._defaultCustomSwitcher.find( "#defaultSwitcher" );
    this._customSwitcher = this._defaultCustomSwitcher.find( "#customSwitcher" );
    var that = this;
    this._defaultSwitcher.click(function(){
        if (!that.useDefaultRules)
        {
            that.setUseDefaultRules(true);
            that._onChange();
        }
    });
    this._customSwitcher.click(function(){
        if (that.useDefaultRules)
        {
            that.setUseDefaultRules(false);
            that._onChange();
        }
    });
};

AdvancedBalanceRulesEditor.prototype._createSwitcher = function (switcherPlaceholder)
{
    switcherPlaceholder.html("");
    var switcherEl = document.createElement("div");
    switcherEl.className = "defaultCustomSwitcher";

    var defaultSwitcher = document.createElement("div");
    defaultSwitcher.id = "defaultSwitcher";
    defaultSwitcher.className = "switcher";
    $(defaultSwitcher ).html("<span>" + messageResource.getMessage( "balance_rules_editor.default" ) + "</span>");

    var customSwitcher = document.createElement("div");
    customSwitcher.id = "customSwitcher";
    customSwitcher.className = "switcher";
    $(customSwitcher).html("<span>" + messageResource.getMessage( "balance_rules_editor.custom" ) + "</span>");

    switcherEl.appendChild(defaultSwitcher);
    switcherEl.appendChild(customSwitcher);
    switcherPlaceholder.append(switcherEl);

    return $(switcherEl);
};

AdvancedBalanceRulesEditor.prototype.isUseDefault = function ()
{
    return this.useDefaultRules;
};


export function BalanceRulesTooltip()
{

}

BalanceRulesTooltip.prototype.init = function(prefixId, countHoursPerDay, parameters )
{
    this._tooltip = $("#" + prefixId + "_balanceRulesDescriptionTooltip");
    this._tooltip.find(".customRules" ).html(messageResource.getMessage(parameters.customTitleTooltip));
    this._tooltip.find(".defaultRules" ).html(messageResource.getMessage(parameters.defaultTitleTooltip));
    this._rulesViewer = new BalanceRulesViewer();
    this._rulesViewer.init(prefixId, this._tooltip, true, countHoursPerDay);
};

BalanceRulesTooltip.prototype.show = function()
{
    this._tooltip.show();
};

BalanceRulesTooltip.prototype.hide = function()
{
    this._tooltip.hide();
};

BalanceRulesTooltip.prototype.moveTo = function(x, y)
{
    this._tooltip[0].style.left = x + "px";
    this._tooltip[0].style.top = y + "px";
};

BalanceRulesTooltip.prototype.getEl = function()
{
    return this._tooltip;
};

BalanceRulesTooltip.prototype.setDefaultBalanceData = function(defaultBalanceData)
{
    this._rulesViewer.setDefaultBalanceData(defaultBalanceData);
};

BalanceRulesTooltip.prototype.setValues = function(values)
{
    this._rulesViewer.setValues(values);
};

BalanceRulesTooltip.prototype.setBalanceData = function(balanceData)
{
    this._rulesViewer.setBalanceData(balanceData);
};

BalanceRulesTooltip.prototype.setWorkdayDurationInHours = function (workdayDurationInHours)
{
    this._rulesViewer.setWorkdayDurationInHours(workdayDurationInHours);
};

BalanceRulesTooltip.prototype.setDefault = function(isDefault)
{
    this._tooltip.toggleClass("default", isDefault);
};

BalanceRulesTooltip.prototype.switchToHours = function ()
{
    this._rulesViewer.setBalanceUnits(LeaveBalanceUnits.HOURS);
};



export function BalanceRulesViewer()
{

}

BalanceRulesViewer.prototype = new BaseBalanceRulesControl();

BalanceRulesViewer.prototype.init = function(prefixId, contentDiv, hideDisabledRules, countHoursPerDay, decimalSeparator, showAdditionalInfo, today)
{
    BaseBalanceRulesControl.prototype.init.call( this, countHoursPerDay );
    this.prefixId = prefixId;
    this.decimalSeparator = decimalSeparator ? decimalSeparator : SystemSettings.decimalSeparator;

    this.daysFormatter = new NumberFormatter(this.decimalSeparator, SystemSettings.digitGroupingSymbol, 2, true, '',
                                             messageResource.getMessage("common.balance_units.days.short"));
    this.hoursFormatter = new NumberFormatter(this.decimalSeparator, SystemSettings.digitGroupingSymbol, 2, true, '',
                                             messageResource.getMessage("common.balance_units.hours.short"));

    this.format = function(value)
    {
        if (this.units == LeaveBalanceUnits.DAYS)
            return this.daysFormatter.format(value);
        else if (this.units == LeaveBalanceUnits.HOURS)
            return this.hoursFormatter.format(value);
        return value;
    };

    this.contentDiv = $(contentDiv);

    this.accrualRuleDiv = this.contentDiv.find(".readOnlyAccrualRule" );
    this.resetRuleDiv = this.contentDiv.find(".readOnlyResetRule" );
    this.capRuleDiv = this.contentDiv.find(".readOnlyCapRule" );

    this.hideDisabledRules = hideDisabledRules;
    this.showAdditionalInfo = showAdditionalInfo
    this.today = today
};

BalanceRulesViewer.prototype._fillElementsWithValues = function(useDefault, noBold, isShort)
{
    var values = useDefault ? this.defaultValues : this._getValues();

    this.accrualRuleDiv.html(
            messageResource.getMessage( noBold ? "balance_rules_editor.balance_rules.accrue_rule_no_bold" : "balance_rules_editor.balance_rules.accrue_rule",
                                        [ this.format(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE]),
                                          CalendarFrequencyType.descriptionFor[values[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE]],
                                          CalendarFrequencyType.parametersFormatterFor[values[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE]](values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS], isShort)]
            ));

    this.resetRuleDiv.html(
            messageResource.getMessage( noBold ? "balance_rules_editor.balance_rules.reset_rule_no_bold" : "balance_rules_editor.balance_rules.reset_rule",
                                        [ this.format(values[BALANCE_RULES_VALUES.RESET_RULE_VALUE]),
                                          CalendarFrequencyType.descriptionFor[values[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE]],
                                          CalendarFrequencyType.parametersFormatterFor[values[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE]](values[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS])]
            ));

    this.capRuleDiv.html(
            messageResource.getMessage( noBold ? "balance_rules_editor.balance_rules.cap_rule_no_bold" : "balance_rules_editor.balance_rules.cap_rule",
                                        [ this.format(values[BALANCE_RULES_VALUES.CAP_RULE_VALUE]) ]
            ));

    if (this.hideDisabledRules)
    {
        this.accrualRuleDiv.toggle(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED]);
        this.resetRuleDiv.toggle(values[BALANCE_RULES_VALUES.RESET_RULE_ENABLED]);
        this.capRuleDiv.toggle(values[BALANCE_RULES_VALUES.CAP_RULE_ENABLED]);

        if (!values[BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED] && !values[BALANCE_RULES_VALUES.RESET_RULE_ENABLED] && !values[BALANCE_RULES_VALUES.CAP_RULE_ENABLED])
        {
            this.accrualRuleDiv.html(messageResource.getMessage( "balance_rules_editor.no_accrual_rules." + this.prefixId ));
            this.accrualRuleDiv.toggle(true);
        }
    }

    if (this.showAdditionalInfo) {
        if (values[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE] === CalendarFrequencyType.BIWEEKLY && this.today) {
            var nextDate = ClassicBridge.getShortNextBiweeklyAccrualDateFromDate(this.today, values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS], SystemSettings.dateFormat)
            this.accrualRuleDiv.append(', ' + messageResource.getMessage('balance_editor.next_accrual_date.short', [nextDate]))
        }
    }
};

BalanceRulesViewer.prototype.updateValues = function()
{
    this._fillElementsWithValues(false);
};



export function BalanceRulesEditorDialog()
{

}

BalanceRulesEditorDialog.prototype.init = function(prefixId, countHoursPerDay, parameters )
{
    var that = this;
    this.dialogDiv = $("#" + prefixId + "_balanceRulesEditorDialog");
    this._balanceRulesEditor = new AdvancedBalanceRulesEditor(prefixId, parameters, null, this.dialogDiv.find(".switcherPlaceholder"), countHoursPerDay);
    this._balanceRulesEditor.init();

    this.wrapperClass = "balanceRulesEditorDialog";

    this._modifyBalanceAccrualRulesDialog = new DropdownDialog({
                                                               dialogDiv: this.dialogDiv,
                                                               okButtonText: messageResource.getMessage("common.buttons.save_changes"),
                                                               wrapperClass: this.wrapperClass,
                                                               showEmptyTitleBar: true,
                                                               onClose: function() {
                                                                   if (that.closeCallback) that.closeCallback();
                                                               },
                                                               hideOnResize: true
                                                           });

    this._createGradientButtons();

    this._buttonsEnabled = true;
};

BalanceRulesEditorDialog.prototype.setToday = function(today)
{
    this._balanceRulesEditor.setToday(today)
}

BalanceRulesEditorDialog.prototype.updateDefaultBalanceNote = function()
{
    this._balanceRulesEditor.updateDefaultBalanceNote()
}


BalanceRulesEditorDialog.prototype._createGradientButtons = function()
{
    this.dialogDiv.parent().find(".ui-dialog-buttonpane div" ).remove();
    var buttonsPane =  this.dialogDiv.parent().find(".ui-dialog-buttonpane");
    this._buttonsPane = $(buttonsPane);

    var that = this;
    this._createSaveButton(buttonsPane);

    this._createGradientButton(buttonsPane, messageResource.getMessage("common.cancel"), "greyButton",
                               function () { that._modifyBalanceAccrualRulesDialog.hide(); } );
};

BalanceRulesEditorDialog.prototype._createSaveButton = function ( buttonsPane )
{
    var that = this;
    var saveButton = this._createGradientButton(buttonsPane, messageResource.getMessage("common.buttons.save_changes"), "greyButton" ,
                                                  function () {
                                                      if (that._onModifyBalanceAccrualRulesOkClick())
                                                          that._modifyBalanceAccrualRulesDialog.hide();
                                                  }
    );
    var spanEl = document.createElement( "span" );
    spanEl.className = "savingText";
    spanEl.innerHTML = messageResource.getMessage("common.saving.ellipsis");

    $(saveButton).addClass("saveButton");
    saveButton.appendChild( spanEl );

    return saveButton;
};

BalanceRulesEditorDialog.prototype._createGradientButton = function ( buttonsPane, text, className, callback ){

    var buttonEl = document.createElement( "div" );
    buttonEl.className = className;

    var spanEl = document.createElement( "span" );
    spanEl.innerHTML = text;

    buttonEl.appendChild( spanEl );

    buttonsPane[0].appendChild( buttonEl );

    var that = this;
    $(buttonEl).click( function () {
        if (that._buttonsEnabled)
            callback();
    } );

    return buttonEl;
};

BalanceRulesEditorDialog.prototype.setUseDefaultRules = function (useDefaultRules)
{
    this._balanceRulesEditor.setUseDefaultRules(useDefaultRules);
};

BalanceRulesEditorDialog.prototype.setValues = function (values)
{
    this._balanceRulesEditor.setValues(values);
};

BalanceRulesEditorDialog.prototype.setBalanceData = function (balanceData)
{
    this._balanceRulesEditor.setBalanceData(balanceData);
};

BalanceRulesEditorDialog.prototype.setDefaultBalanceData = function (values)
{
    this._balanceRulesEditor.setDefaultBalanceData(values);
};

BalanceRulesEditorDialog.prototype.setWorkdayDurationInHours = function (workdayDurationInHours)
{
    this._balanceRulesEditor.setWorkdayDurationInHours(workdayDurationInHours);
};

BalanceRulesEditorDialog.prototype.showAt = function (element, params)
{
    this._modifyBalanceAccrualRulesDialog.showAt(element, params);
};

BalanceRulesEditorDialog.prototype.setModifyBalanceAccrualRulesOkClick = function(callback) {
    var that = this;
    this._onModifyBalanceAccrualRulesOkClick = function() {
        if (!that._balanceRulesEditor.hasErrors())
        {
            this._buttonsEnabled = false;
            this._modifyBalanceAccrualRulesDialog.preventClose();
            this._buttonsPane.addClass('savingMode');

            callback();
            return true;
        }
        else
            that._balanceRulesEditor.blinkErrors();
        return false;
    }
};

BalanceRulesEditorDialog.prototype.getAccrualRules = function ()
{
    return this._balanceRulesEditor.getAccrualRules();
};

BalanceRulesEditorDialog.prototype.switchToHours = function ()
{
    this._balanceRulesEditor.switchToHours();
};

BalanceRulesEditorDialog.prototype.isUseDefault = function ()
{
    return this._balanceRulesEditor.isUseDefault();
};

BalanceRulesEditorDialog.prototype.setOnCloseCallback = function (closeCallback)
{
    this.closeCallback = closeCallback;
};

BalanceRulesEditorDialog.prototype.hide = function()
{
    this._buttonsPane.removeClass('savingMode');
    this._buttonsEnabled = true;
    this._modifyBalanceAccrualRulesDialog.allowClose();
    this._modifyBalanceAccrualRulesDialog.hide();
};

// ------------------------------------------------------ //

export function BalanceRulesManager() {}

BalanceRulesManager.prototype.init = function (prefixId, balanceDefaults, countHoursPerDay, parameters ) {
    this._balanceAccrualRulesDialog = new BalanceRulesEditorDialog();
    this._balanceAccrualRulesDialog.init(prefixId, countHoursPerDay, parameters );
    this._balanceAccrualRulesDialog.setDefaultBalanceData(balanceDefaults);

    this._balanceAccrualRulesTooltip = new BalanceRulesTooltip();
    this._balanceAccrualRulesTooltip.init(prefixId, countHoursPerDay, parameters );
    this._balanceAccrualRulesTooltip.setDefaultBalanceData(balanceDefaults);

    //TODO: evdokimov hot fix.
    if ( balanceDefaults && balanceDefaults.showBalanceInHours)
    {
        this._balanceAccrualRulesDialog.switchToHours();
        this._balanceAccrualRulesTooltip.switchToHours();
    }

    return this;
};

BalanceRulesManager.prototype.reinitAccrualRulesControls = function ( countHoursPerDay ) {
    this._balanceAccrualRulesDialog.setWorkdayDurationInHours( countHoursPerDay );
    this._balanceAccrualRulesTooltip.setWorkdayDurationInHours( countHoursPerDay );
};

BalanceRulesManager.prototype.showAccrualRulesTooltip = function ( jQueryEvent, balanceData ) {
    if( !balanceData )
        return;
    this._balanceAccrualRulesTooltip.setDefault(balanceData.defaultRules);

    this._balanceAccrualRulesTooltip.setBalanceData( balanceData );
    var offset = this._getTooltipOffset( jQueryEvent, this._balanceAccrualRulesTooltip.getEl() );
    this._balanceAccrualRulesTooltip.moveTo( offset.left, offset.top );
    this._balanceAccrualRulesTooltip.show();
};

BalanceRulesManager.prototype.hideAccrualRulesTooltip = function () {
    this._balanceAccrualRulesTooltip.hide();
};

BalanceRulesManager.prototype.hideAccrualRulesTooltip = function () {
    this._balanceAccrualRulesTooltip.hide();
};

BalanceRulesManager.prototype.moveAccrualRulesTooltip = function ( jQueryEvent ) {
    var offset = this._getTooltipOffset( jQueryEvent, this._balanceAccrualRulesTooltip.getEl() );
    this._balanceAccrualRulesTooltip.moveTo( offset.left, offset.top );
};

BalanceRulesManager.prototype._getTooltipOffset = function( jQueryEvent, tooltipEl ) {
    var BOTTOM_BAR_HEIGHT = 26;
    var top = jQueryEvent.pageY + 5;
    var tooltipHeight = $( tooltipEl ).outerHeight();
    if ( top + tooltipHeight + BOTTOM_BAR_HEIGHT - getBodyScrollTop() > $(window).height() )
        top -= tooltipHeight;

    return { top: top, left: jQueryEvent.pageX + 15 };
};

BalanceRulesManager.prototype.updateDialog = function ( balanceData, today ) {
    this._balanceAccrualRulesDialog.setToday(today)
    this._balanceAccrualRulesDialog.updateDefaultBalanceNote()

    if ( balanceData.defaultRules )
    {
        this._balanceAccrualRulesDialog.setBalanceData(null);
        this._balanceAccrualRulesDialog.setUseDefaultRules(true);
    }
    else
    {
        this._balanceAccrualRulesDialog.setBalanceData(balanceData);
        this._balanceAccrualRulesDialog.setUseDefaultRules(false);
    }
};

BalanceRulesManager.prototype.setModifyBalanceAccrualRulesOkClick = function( callback ) {
    this._balanceAccrualRulesDialog.setModifyBalanceAccrualRulesOkClick(callback);
};

BalanceRulesManager.prototype.setOnCloseCallback = function ( closeCallback ) {
    this._balanceAccrualRulesDialog.setOnCloseCallback(closeCallback);
};

BalanceRulesManager.prototype.showDialogAt = function ( target, offset )  {
    this._balanceAccrualRulesDialog.showAt(target, offset);
};

BalanceRulesManager.prototype.hideDialog = function ()  {
    this._balanceAccrualRulesDialog.hide();
};

BalanceRulesManager.prototype.getDialogValues = function ()  {
    var result =  { useDefaults: this._balanceAccrualRulesDialog.isUseDefault(), accrualRule: null, resetRule: null, capRule: null };

    if ( !result.useDefaults )
    {
        var rules = this._balanceAccrualRulesDialog.getAccrualRules();
        if ( rules ) {
            result.accrualRule = rules.accrualRule;
            result.resetRule = rules.resetRule;
            result.capRule = rules.balanceCap;
        }
    }

    return result;
};





// WEBPACK FOOTER //
// ./web/js/controls/BalanceRulesEditor.js